module.exports = __webpack_public_path__ + "img/source-sans-pro-v13-latin-900.5737a0d8.svg";